import React from "react";
import PropTypes from "prop-types";
import styles from "./CardItem.module.css";
import { Toggler } from "../Toggler/Toggler";
import { TrashButton } from "../TrashButton/TrashButton"; // Assuming TrashButton is a custom component
import { Button } from "../Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcDinersClub,
  faCcJcb,
} from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";

const cardTypeToIcon = {
  visa: faCcVisa,
  mastercard: faCcMastercard,
  "discover card": faCcDiscover,
  discover: faCcDiscover,
  "diners club": faCcDinersClub,
  "diners club international": faCcDinersClub,
  jcb: faCcJcb,
};

function getCardIcon(cardType) {
  return cardTypeToIcon[cardType.toLowerCase()];
}

export function CardItem({ cardInfo, primary, setPrimary, onEdit, onDelete }) {
  const handleToggleChange = () => {
    if (setPrimary) {
      setPrimary(cardInfo.id);
    }
  };

  const isDeleteDisabled = cardInfo.isPrimary;
  const {t} = useTranslation();

  //Check card expiration, disable if expired
  const checkCardExpiration = (expireMonth, expireYear) => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    if (parseInt(expireYear) > currentYear) {
      return true;
    } else if (parseInt(expireYear) === currentYear) {
      return parseInt(expireMonth) >= currentMonth;
    } else {
      return false;
    }
  };

  const isNotExpired = checkCardExpiration(cardInfo.expMonth, cardInfo.expYear);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.cardImage}>
          <FontAwesomeIcon
            icon={getCardIcon(cardInfo.cardType)}
            aria-hidden="true"
            style={{ width: "50pt", height: "32pt" }}
          />
        </div>
        <div className={styles.cardDetails}>
          <div className={styles.cardNumber}>
            <p className={styles.lastFour}>
              {t("Ending in")} {cardInfo.lastFour}
            </p>
            <p>
              Exp: {cardInfo.expMonth}/{cardInfo.expYear}
            </p>
            <p hidden>{cardInfo.zipCode}</p>
          </div>
          <div className={styles.cardNickName}>{cardInfo.nickName}</div>
        </div>
      </div>
      <div className={styles.buttons}>
        {isNotExpired ? (
          <>
            <p className={styles.primaryText}>{t("Primary")}</p>
            <Toggler
              toggled={primary}
              color={primary ? "#39B54A" : "#D3D3D3"}
              onChange={handleToggleChange}
            />
          </>
        ) : (
          <>
            <p className={styles.expiredText}>{t("Expired")}</p>
          </>
        )}

        <Button
          buttonText={t("Edit")}
          onClick={onEdit}
          className={styles.editButton}
        />
        <TrashButton
          onClick={onDelete}
          disabled={isDeleteDisabled} // Pass disabled state
        />
      </div>
    </div>
  );
}

CardItem.propTypes = {
  cardInfo: PropTypes.shape({
    zipCode: PropTypes.string,
    nickName: PropTypes.string,
    lastFour: PropTypes.string,
    expYear: PropTypes.string,
    expMonth: PropTypes.string,
    cardType: PropTypes.string,
    isPrimary: PropTypes.bool,
  }).isRequired,
  primary: PropTypes.bool,
  setPrimary: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CardItem;
